<template>
  <div class="p-grid p-justify-center">
    <div class="p-col-8">
      <h1 class="title is-1">{{ $t("AppMenu.new-season") }}</h1>
      <p v-if="error" class="error">
        {{ error }}
      </p>
      <div class="p-my-3 m0" v-if="!copy">
        <h3 class="p-mb-3">{{ $t("what-would-you-like-to-do") }}</h3>
        <Button class="p-button-lg p-button-outlined" @click="goRouter('/setup')">{{ $t("create-new-season") }}</Button>
        &nbsp; &nbsp;
        <Button class="p-button-lg p-button-outlined" @click="copy = true">{{ $t("copy-existing-season") }} </Button>
      </div>

      <div v-if="copy" class="p-mt-3" style="margin: 0 auto;">
        <InputText :placeholder="$t('new-season-name')" class="fs15 p-mt-3" autofocus="true" v-model="season_name" />
        <br /><br />
        <Dropdown
          :options="leagueInfo.currentLeagueSeasons"
          optionLabel="label"
          :placeholder="$t('select-season-to-copy')"
          class="p-my-3"
          style="width: 100%;"
          optionValue="value"
          v-model="season_id"
        />
        <br />
        <strong>{{ $t("do-you-want-to-copy-over-existing-timeslots") }}</strong>
        <br /><br />
        <div class="p-field-radiobutton">
          <RadioButton id="city1" name="city" style="max-width: unset" :value="false" v-model="copyTimeslots" />
          <label for="city1">{{ $t("dont-schedules-timeslots") }}</label>
        </div>
        <br />
        <div class="p-field-radiobutton">
          <RadioButton id="city2" name="city" style="max-width: unset" :value="true" v-model="copyTimeslots" />
          <label for="city2">{{ $t("copy-schedules-timeslots") }}</label>
        </div>
        <!-- <div v-if="copyTimeslots" class="p-my-1">
              <Dropdown
                :options="timeslotOptions"
                optionLabel="name"
                placeholder="Select Copy Distance"
                style="width: 100%"
                class="p-mt-3"
                optionValue="value"
                v-model="timeslotMove"
              />
            </div> -->
        <br /><br />
        <div class="p-field-checkbox p-mt-3" style="display: block; margin: 0 auto">
          <Checkbox id="binary" v-model="copyPeople" :binary="true" />
          <label for="binary">{{ $t("copy-people") }}</label>
        </div>

        <div class="p-my-3">
          <Button
            v-if="!isLoading"
            :label="$t('create-season-copy')"
            :disabled="!season_name || !season_id"
            @click="createSeason"
          />
          <div v-else class="isLoadingDiv">
            <ProgressSpinner />
          </div>
        </div>
      </div>
      <!-- <form @submit.prevent="createSeason" autocomplete="off">
            <b-field label="Season Name">
                <b-input 
                  autofocus="true"
                  v-model.trim="name"
                  placeholder="Fall Ball 2020">
                </b-input>
            </b-field>
            <button type="submit" class="button">
              Create Season
            </button>
          </form> -->
    </div>
  </div>
</template>

<script>
import Errors from "@/components/Errors";
import api from "@/api";

export default {
  components: { Errors },
  data() {
    return {
      isLoading: false,
      season_name: "",
      error: "",
      copy: false,
      copyTimeslots: false,
      copyPeople: false,
      timeslotMove: 0,
      season_id: null,
    };
  },
  computed: {
    leagueOptions() {},
    seasonOptions() {},
    timeslotOptions() {
      var x = [
        {
          name: this.$t("0-months-dont-move"),
          value: 0,
        },
        {
          name: this.$t("1-month"),
          value: 1,
        },
      ];
      var i = 2;
      while (i <= 12) {
        x.push({
          name: i + " months",
          value: i,
        });
        i++;
      }
      return x;
    },
  },
  methods: {
    createSeason() {
      this.isLoading = true;
      api
        .copySeason({
          name: this.season_name,
          season_id: this.season_id,
          copyTimeslots: this.copyTimeslots,
          copyPeople: this.copyPeople,
          timeslotMove: this.timeslotMove,
        })
        .then(response => {
          if (!this.isProduction) {
            this.isLoading = false;
            return;
          }
          console.log(response);
          console.log("Set", response.data.league.id, response.data.season.id);
          this.setCurrentLeagueSeasonId(response.data.league.id, response.data.season.id);
          setTimeout(() => {
            this.goRouter(`/`);
          }, 2000);
        })
        .catch(error => {
          console.log("Error", error);
          this.isLoading = false;
          // this.errors = error.response.data.errors;
        });
    },
  },
  mounted() {
    window.analytics.page();
  },
};
</script>

<style scoped lang="scss">
form {
  margin-top: 1rem;
}

.p-field-radiobutton {
  max-width: 500px;
  margin: 0 auto;
  display: block;
}

.p-dropdown {
  max-width: 300px;
  margin: 0 auto;
}
</style>
